import domReady from '@wordpress/dom-ready';
import locationPinSVG from './assets/svg/location-pin.svg?url';

// Map initialisation
function initMap() {
    const mapDisplay = document.querySelector('#tourinsoft-map');

    if (!mapDisplay) {
        return;
    }

    const customIcon = L.icon({
        iconUrl: '/wp-content/plugins/gct-tourinsoft/src/Blocks/build/' + locationPinSVG,
        iconSize: [40, 40],
        iconAnchor: [20, 40],
        popupAnchor: [0, -40]
    });

    const placeholder = 'http://www.chateaudun-tourisme.fr.dev2.tribu-and-co.com/wp-content/plugins/tribu-blocks/src/tourinsoft-activity-list/assets/img/tourinsoft-placeholder.jpg';

    const locations = JSON.parse(
        mapDisplay.dataset.locations || '[]'
    );

    if (mapDisplay._leaflet_id) {
        mapDisplay._leaflet_id = null;
    }

    const map = L.map('tourinsoft-map', {    closePopupOnClick: false    }).setView([46.6, 2.5], 10);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap'
    }).addTo(map);

    const markersCluster = L.markerClusterGroup({
        maxClusterRadius: 30,
        zoomToBoundsOnClick: true,
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,

        iconCreateFunction(cluster) {
            return L.divIcon({
                html: `<div class="custom-cluster">${cluster.getChildCount()}</div>`,
                className: 'my-cluster-icon',
                iconSize: L.point(40, 40)
            });
        }
    });

    locations.forEach(({ lat, lng, title, location, photo, url }) => {
        const popupContent = `
            <div class="leaflet-popup-card">
                <a href="${url}">
                    ${photo}
                    <div class="leaflet-popup-description">
                        <h4 class="leaflet-popup-description__title">${title}</h4>
                        <p class="leaflet-popup-description__location tourinsoft-card__content-location">${location}</p>
                    </div>
                </a>
            </div>
        `;

        const marker = L.marker([lat, lng], {
            icon: customIcon
        }).bindPopup(popupContent, {
            autoClose: true,
            closeOnClick: false,
            autoPan: true,
        });

        markersCluster.addLayer(marker);
    });

    map.addLayer(markersCluster);

    if (locations.length) {
        map.fitBounds(markersCluster.getBounds().pad(1));
    }

}

domReady(function () {
    const root = document.querySelector('#ts-app');
    const endpoint = root.dataset.endpoint;
    const displayRuleId = root.dataset.displayRuleId;
    const blockID = root.dataset.blockId;
    let filtersForm = root.querySelector('#ts-filters-form');
    let cardsWrapper = root.querySelector('#ts-cards-list');
    let filtersWrapper = root.querySelector('#ts-filters-list');
    let paginationLinks = [...cardsWrapper.querySelectorAll('.page-numbers[data-page]')];
    let requestedPage = 1;

    const closeBtn = document.querySelector('.tourinsoft-map-close-btn');

    if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
            e.preventDefault();

            const mapDisplay = document.querySelector('#tourinsoft-map');

            if (mapDisplay) {
                mapDisplay.classList.remove('is-active');
            }
        });
    }

    document.addEventListener('click', function (e) {

        // Map button
        const mapBtn = e.target.closest('.tourinsoft-activity-map');

        if (mapBtn) {
            e.preventDefault();

            const mapDisplay = document.querySelector('#tourinsoft-map');

            if (!mapDisplay) {
                return;
            }

            mapDisplay.classList.toggle('is-active');
            mapBtn.classList.toggle('is-active');

            mapBtn.textContent = mapBtn.classList.contains('is-active')
                ? mapBtn.dataset.closeText
                : mapBtn.dataset.openText;

            return;
        }

        // Mobile filters button
        const filterBtn = e.target.closest('.filter-toggle-btn');
        if (filterBtn) {
            e.preventDefault();

            const form = document.querySelector(
                '.tourinsoft-activity-list-reservation-form'
            );

            if (!form) {
                return;
            }

            form.classList.toggle('is-open');
        }
    });

    const getFilters = () => {
        const f = {
            tourinsoft_syndication_id: root.dataset.syndicationId,
            page: requestedPage,
            block_id: blockID
        }
        filtersForm.querySelectorAll('.ts-filter').forEach(filter => {
            const filterType = filter.dataset.filterType;

            switch (filterType) {
                case 'checkbox':
                    filter.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
                        const k = cb.dataset.key;
                        
                        if(!k || !cb.value) return;

                        if (!f[k]) f[k] = [];
                        f[k].push(cb.value);
                    });
                break;

                case 'select':
                    const select = filter.querySelector('select');
                    if (select && select.value) {
                        f[select.dataset.key] = select.value;
                    }
                break;

                case 'period':
                    filter.querySelectorAll('input[type="date"]').forEach(cb => {
                        const k = cb.dataset.key;
                        
                        if(!k || !cb.value) return;

                        if (!f[k]) f[k] = [];

                        if (cb.name === 'period[from]') {
                            f[k][0] = cb.value;
                        } else if (cb.name === 'period[to]') {
                            f[k][1] = cb.value;
                        }
                    });
                break;
            }
        });
        
        return f;
    };

    const refresh = async () => {
        const filters = getFilters();
        const params = new URLSearchParams();

        Object.entries(filters).forEach(([k,v]) => {
            params.append(k, Array.isArray(v) ? v.join('|') : v)
        });

        params.append('display_rule_id', displayRuleId);

        const res = await fetch(endpoint + '?' + params);
        const data = await res.json();

        render(data);
    };

    const render = (data) => {
        unbind();

        cardsWrapper.replaceWith(document.createRange().createContextualFragment(data.cards).firstElementChild);
        filtersWrapper.replaceWith(document.createRange().createContextualFragment(data.filters).firstElementChild);

        filtersForm = root.querySelector('#ts-filters-form');
        cardsWrapper = root.querySelector('#ts-cards-list');
        filtersWrapper = root.querySelector('#ts-filters-list');
        paginationLinks = [...cardsWrapper.querySelectorAll('.page-numbers[data-page]')];
   
     
        bind();

        initMap();
    };

    const bind = () => {
        filtersForm.addEventListener('submit', onFiltersSubmit);
        paginationLinks.forEach((link) => {
            link.addEventListener('click', onPaginationClick);
        });
    };
    const unbind = () => {
        filtersForm.removeEventListener('submit', onFiltersSubmit);
        paginationLinks.forEach((link) => {
            link.removeEventListener('click', onPaginationClick);
        });
    };
    const onFiltersSubmit = (e) => {
        e.preventDefault();
        
        requestedPage = 1;

        const activityList = document.querySelector('.tourinsoft-activity-list');

        if (activityList) {
            activityList.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }

        refresh();
    };
    const onPaginationClick = (e) => {
        const {page} = e.target.dataset;
        const pageNumber = page ? parseInt(page, 10) : null;

        if(pageNumber) {
            requestedPage = pageNumber;

            const activityList = document.querySelector('.tourinsoft-activity-list');

            if (activityList) {
                activityList.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }

            refresh();
        }
    };

    bind();
    initMap();
});